import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Operations from '../../operations'
import { history } from '../../store'

export class GroupsPlaceholderHome extends Component {
  componentDidMount() {
    history.push(`/homes`)
  }

  render() {
    return (
      <div style={{ paddingTop: 20 }}>
        <h2>Groups Home Placeholder Screen</h2>
        <ul>
          <li>
            <Link to="/organisation">Team</Link>
          </li>
          <li>
            <Link to="/homes">Sites</Link>
          </li>
          <li>
            <Link to="/group-reports">Reports</Link>
          </li>
        </ul>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    homes: state.data.homes,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchLists: () => {
      dispatch(Operations.loadList('homes'))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupsPlaceholderHome)
